import React from "react";
import { View } from "react-native";
import { registrationStyles as styles } from "../styles/registrationStyles";
import HeaderBack from "../component/HeaderBack";
import { RootStackParamList } from "../../../types/navigation";
import { RouteProp } from "@react-navigation/native";

interface RestaurantMenuScreenProps {
  route: RouteProp<RootStackParamList, "UserAccountScreen">;
}
const UserAccountScreen = ({ route }: RestaurantMenuScreenProps) => {
  return (
    <View style={styles.container}>
      <HeaderBack title="Edit Account" />
    </View>
  );
};

export default UserAccountScreen;
